import { CSSProperties, forwardRef } from 'react';

type AutomatedPatientIframeProps = {
  className?: string;
  style?: CSSProperties;
  allow?: string;
};

/**
 * Renders the invisible automated patient iframe. Include once per page
 * (e.g. clinician test session) so the automated patient initializes in the background.
 */
export const AutomatedPatientIframe = forwardRef<HTMLIFrameElement, AutomatedPatientIframeProps>(
  ({ className, style, allow }, ref) => (
    <iframe
      ref={ref}
      title="Automated Patient"
      src="/automated-patient-dev"
      allow={allow ?? 'camera; microphone; autoplay'}
      className={className}
      style={{
        width: 0,
        height: 0,
        border: 0,
        opacity: 0,
        position: 'absolute',
        pointerEvents: 'none',
        ...style
      }}
    />
  )
);

AutomatedPatientIframe.displayName = 'AutomatedPatientIframe';
